import {
  applyCoupon,
  setCartItemQuantity,
} from './cartServices'

import {
  initializeCheckout,
  getCart,
  getOrderWithPayments,
  getOrder,
  getCompletedOrder,
  initializeOrderConfirmation,
} from './orderServices'

import {
  goToCart,
  goToHome,
  goToConfirmation,
  setPageTitle,
  setCustomerLocalStorage,
  getPageUrl,
  updateCurrentPathTo,
  reloadPage,
} from './navigationServices'

import {
  getAddresses,
  getPlacesKey,
  getPlacesPredictions,
  getNonShippedStates,
  saveAddressToUser,
  deleteAddress,
} from './addressServices'

import {
  getCustomer,
  signUserIn,
} from './customerServices'

import {
  gaCheckoutEvents,
  gaCustomer,
  gaTrackFields,
  gaUserStatus,
  bounceXPixelTracking,
  emailOptIn,
  getExperiment,
  heapOrderTracking,
  heapPurchaseTracking,
  heapCustomer,
  recordAbandonedCartEmail,
  getCitizensPayReferenceId,
  listrakEmailCapture
} from './thridPartyServices'

import {
  updateShippingOption,
  updateShippingAddress,
} from './shipmentServices'

import {
  updateBillingAddress,
  checkoutWithPaypal,
  createPaymentToken,
  completePayment,
  getPaymentMethods,
  createPaymentMethod,
  setPaymentMethod,
  payForOrder,
  deletePaymentMethod,
} from './paymentServices'

import { getBranding } from './brandServices'

import {
  displayLoyaltyProgramSignup,
  redeemLoyaltyBalance,
  getLoyaltyBannerInfo,
  removeStoreCredit,
  isCustomerInLoyaltyProgram,
} from './loyaltyServices'

//---------------------------------------------

export default {
  heapCustomer,
  heapOrderTracking,
  heapPurchaseTracking,
  getCart,
  setCartItemQuantity,
  applyCoupon,
  getOrder,
  getCompletedOrder,
  getCustomer,
  signUserIn,
  emailOptIn,
  recordAbandonedCartEmail,
  reloadPage,
  getAddresses,
  saveAddressToUser,
  deleteAddress,
  getOrderWithPayments,
  updateShippingOption,
  updateShippingAddress,
  updateBillingAddress,
  createPaymentToken,
  completePayment,
  checkoutWithPaypal,
  getPaymentMethods,
  createPaymentMethod,
  setPaymentMethod,
  deletePaymentMethod,
  payForOrder,
  getBranding,
  goToCart,
  goToConfirmation,
  goToHome,
  gaCheckoutEvents,
  setPageTitle,
  updateCurrentPathTo,
  gaCustomer,
  gaTrackFields,
  gaUserStatus,
  getPlacesPredictions,
  getPlacesKey,
  getNonShippedStates,
  setCustomerLocalStorage,
  bounceXPixelTracking,
  getPageUrl,
  getExperiment,
  initializeCheckout,
  initializeOrderConfirmation,
  displayLoyaltyProgramSignup,
  redeemLoyaltyBalance,
  getLoyaltyBannerInfo,
  getCitizensPayReferenceId,
  removeStoreCredit,
  isCustomerInLoyaltyProgram,
  listrakEmailCapture
}
